export default __webpack_public_path__ + "static/gocheapwebsite-d190dffb429f4f02708521c86a1bf701.png";